import PropTypes from 'prop-types';

export const Features = {
  DISPLAY_GRID: 'display-grid',
};

const FeaturesSupport = new Map([
  [Features.DISPLAY_GRID, typeof document.createElement('div').style.grid === 'string'],
]);

export const isFeatureSupported = (f) => FeaturesSupport.get(f);

function RequiresFeature({ children, features, substitute }) {
  return (features.every(isFeatureSupported)
    ? children
    : substitute);
}

RequiresFeature.propTypes = {
  children: PropTypes.node.isRequired,
  features: PropTypes.instanceOf(Array).isRequired,
  substitute: PropTypes.node,
};

RequiresFeature.defaultProps = {
  substitute: null,
};

export default RequiresFeature;
